import React, { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';

type JsonObject = { [key: string]: JsonValue };
type JsonValue = string | boolean | number | JsonObject | JsonValue[];
type FeatureFlags = Record<string, JsonValue>;

const FeatureFlagContext = createContext<FeatureFlags>({});

interface FeatureFlagProviderProps {
  children: ReactNode;
}

export const FeatureFlagProvider = ({ children }: FeatureFlagProviderProps) => {
  const ldflags = globalThis.window?.Fulcrum?.globals?.ldflags;
  const flags: FeatureFlags = useMemo(() => ldflags || {}, [ldflags]);

  return (
    <FeatureFlagContext.Provider value={flags}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export function useFeatureFlag<T>(flag: string, defaultValue: T): T {
  const flags = useContext(FeatureFlagContext);

  if (Object.prototype.hasOwnProperty.call(flags, flag)) {
    return flags[flag] as T;
  }

  return defaultValue;
}

export { FeatureFlagContext };
